module.exports = __webpack_public_path__ + "static/media/wheelbarrow.a1e964bd.png";